import { TFunction } from 'i18next'
import * as yup from 'yup'

export const createContactsSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        contact_source_name: yup.string().required(t('blank-errors')),
        contact_source_phone: yup.string().required(t('blank-errors')),
        contact_source_email: yup
            .string()
            .required(t('blank-errors'))
            .email(t('invalid-email')),
        contact_source_position: yup.string().required(t('blank-errors')),
        contact_source_channel: yup.string().required(t('blank-errors')),
        contact_source_status: yup.string().required(t('blank-errors')),
        contact_source_assignee_ids: yup.array().of(yup.number()).nullable(),
        contact_source_industry: yup.string().required(t('blank-errors')),
    })

export const updateContactsSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        contact_source_name: yup.string(),
        contact_source_phone: yup.string(),
        contact_source_email: yup.string().email(t('invalid-email')),
        contact_source_position: yup.string(),
        contact_source_channel: yup.string(),
        contact_source_status: yup.string(),
        contact_source_assignee_ids: yup.array().of(yup.number()),
        contact_source_industry: yup.string().nullable(),
    })
